import { useCallback, useContext } from 'react'
import { DepartmentsTableContext } from '../context'
import { useSelection } from '@shared/modules/next-table/hooks/use-selection'
import { useBackgroundNavigate } from '@shared/hooks'

export const useDepartmentsTableActions = () => {
  const navigate = useBackgroundNavigate()
  const { state, handleFetch, handleReset, handleSelectAll, handleResetSelection } = useContext(DepartmentsTableContext)
  const selection = useSelection(state.selectedRowIds)

  const goToCreate = useCallback(() => {
    navigate('/departments/create', { withBackground: true })
  }, [navigate])

  return { selection, goToCreate, handleFetch, handleResetSelection, handleSelectAll, handleReset }
}
